import React from "react";
import wallaLogo from "./logo/gameswalla-logo.png";

function Header() {
    return (
        <div className="text-center">
            <img className="wallaImg" src={wallaLogo} alt="wallaLogo" style={{marginTop: '80px', marginBottom: '30px'}}/>
        </div>
    );
}

export default Header;